import React from 'react';

const JobDetailsModal = ({ job, onClose, getStatusColor }) => {
  if (!job) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl max-w-2xl w-full max-h-[80vh] overflow-y-auto shadow-2xl">
        <div className="p-6 border-b sticky top-0 bg-white">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold text-gray-900">Job Details</h2>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>
        </div>
        
        <div className="p-6 space-y-6">
          <div>
            <h3 className="text-2xl font-bold text-gray-900">{job.title}</h3>
            <p className="text-gray-500 mt-1">Posted by {job.client_name}</p>
          </div>
          
          <div className="grid grid-cols-2 gap-4">
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm text-gray-500">Budget</p>
              <p className="text-xl font-bold text-gray-900">
                {job.budget ? `₱${job.budget.toLocaleString()}` : 'Negotiable'}
              </p>
            </div>
            <div className="bg-blue-50 p-4 rounded-lg">
              <p className="text-sm text-gray-500">Your Bid</p>
              <p className="text-xl font-bold text-blue-600">
                ₱{job.bid_amount?.toLocaleString()}
              </p>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold text-gray-700 mb-2">Description</h4>
            <p className="text-gray-600 whitespace-pre-line">{job.description}</p>
          </div>
          
          {job.category && (
            <div>
              <h4 className="font-semibold text-gray-700 mb-2">Category</h4>
              <span className="inline-block bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-sm">
                {job.category}
              </span>
            </div>
          )}
          
          {job.location && (
            <div>
              <h4 className="font-semibold text-gray-700 mb-2">Location</h4>
              <p className="text-gray-600">{job.location}</p>
            </div>
          )}
          
          {job.deadline && (
            <div>
              <h4 className="font-semibold text-gray-700 mb-2">Deadline</h4>
              <p className="text-gray-600">
                {new Date(job.deadline).toLocaleDateString('en-US', {
                  year: 'numeric',
                  month: 'long',
                  day: 'numeric'
                })}
              </p>
            </div>
          )}
          
          <div>
            <h4 className="font-semibold text-gray-700 mb-2">Status</h4>
            <span className={`inline-block px-3 py-1 rounded-full text-sm font-medium ${getStatusColor(job.status)}`}>
              {job.status?.charAt(0).toUpperCase() + job.status?.slice(1)}
            </span>
          </div>
        </div>
        
        <div className="p-6 border-t bg-gray-50">
          <button
            onClick={onClose}
            className="w-full py-3 bg-gray-900 text-white rounded-lg font-medium hover:bg-gray-800 transition"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default JobDetailsModal;
